import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { DriverImport, driverSchema } from '../schemas/driver.schema';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Imports Drivers
 * @param drivers The Drivers being imported
 * @returns Data Object containing the imported Drivers
 */
export function postDriversImport(this: unknown, drivers: DriverImport[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).driversImportUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(drivers),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(
          z.object({
            item: driverSchema.omit({ modifiedOn: true }).extend({
              groups: z
                .array(z.object({ driverGroupName: z.string() }))
                .optional()
                .nullable(),
            }),
            importResult: z.string(),
            validationResult: z.string(),
          })
        ),
        message: z.string().nullable(),
      })
    )
  );
}
